import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { typeCustomFields } from "./AdminSettingsApi";

const initialState = {
  customFields: [] as typeCustomFields,
  settingsForm: [] as typeCustomFields,
};

export const adminSettingsSlice = createSlice({
  name: "adminSettings",
  initialState,
  reducers: {
    settingsForm: (
      state,
      action: PayloadAction<typeof initialState.settingsForm>
    ) => {
      state.settingsForm = action.payload;
    },
    setCustomFields: (
      state,
      action: PayloadAction<typeof initialState.customFields>
    ) => {
      state.customFields = action.payload;
    },
    resetApp: () => initialState,
  },
});

export const { resetApp, settingsForm, setCustomFields } =
  adminSettingsSlice.actions;

export default adminSettingsSlice.reducer;
